import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

import "../App.css"; // Importera CSS-filen
import {
  FaHome,
  FaPen,
  FaPlusCircle,
  FaChartLine,
  FaDownload,
  FaEdit,
  FaList,
} from "react-icons/fa";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

const Navbar = () => {
  const { currentUserProfile } = useAuth();

  const role = currentUserProfile?.role;

  const isAdmin = role === "admin";
  const isManager = role === "manager";
  const isEmployee = role === "employee";

  const canEdit = isAdmin;
  const canSeeResults = isAdmin || isManager || isEmployee;
  const canExport = isAdmin;

  const location = useLocation();
  const path = location.pathname;

  const hideNavbar =
    path === "/" || path === "/privacy" || path.startsWith("/feedback/");

  const tenantId = getTenantIdFromHost();
  const isTenant = tenantId !== "localhost" && tenantId !== "root";

  useEffect(() => {
    if (isTenant) {
      let title = tenantId.charAt(0).toUpperCase() + tenantId.slice(1);
      document.title = `${title} – Kundupplevelse, Feedback`;
    } else {
      document.title = "Kundupplevelse, Feedback";
    }
  }, [tenantId]);

  const setFavicon = (tenantId) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return;

    link.href = `/logos/${tenantId}-favicon.ico`;
  };

  useEffect(() => {
    if (tenantId) setFavicon(tenantId);
  }, [tenantId]);

  return (
    <>
      {!hideNavbar ? (
        <nav>
          <ul className="navbar">
            {/* Här ska listan vara horisontell */}
            {canEdit && (
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "active-link" : undefined
                }
              >
                <FaHome />
              </NavLink>
            </li>
             )}
            {canEdit && (
              <li>
                <NavLink
                  to="/builder"
                  className={({ isActive }) =>
                    isActive ? "active-link" : undefined
                  }
                >
                  <FaPlusCircle /> {/* Skapa en undersökning-ikon */}
                </NavLink>
              </li>
            )}

            {canEdit && (
              <li>
                <NavLink
                  to="/survey"
                  className={({ isActive }) =>
                    isActive ? "active-link" : undefined
                  }
                >
                  <FaEdit />
                  {/* Undersökningar-ikon<FaPen /> */}
                </NavLink>
              </li>
            )}
            {canSeeResults && (
              <li>
                <NavLink
                  to="/visualize"
                  className={({ isActive }) =>
                    isActive ? "active-link" : undefined
                  }
                >
                  <FaChartLine /> {/* Se Data-ikon */}
                </NavLink>
              </li>
            )}
             {canEdit && (
              <li>
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    isActive ? "active-link" : undefined
                  }
                >
                  <FaList />
                  {/* Undersökningar-ikon<FaPen /> */}
                </NavLink>
              </li>
            )}
            {canExport && (
              <li>
                <NavLink
                  to="/export"
                  className={({ isActive }) =>
                    isActive ? "active-link" : undefined
                  }
                >
                  <FaDownload /> {/* Exportera Data-ikon */}
                </NavLink>
              </li>
            )}
          </ul>
          <a href="/login" className={"headerLink"}>
            Konto
          </a>
        </nav>
      ) : null}
    </>
  );
};

export default Navbar;
